import { render, staticRenderFns } from "./LiverMedicalDetails.vue?vue&type=template&id=b7a2ac5e"
import script from "./LiverMedicalDetails.vue?vue&type=script&lang=js"
export * from "./LiverMedicalDetails.vue?vue&type=script&lang=js"
import style0 from "./LiverMedicalDetails.vue?vue&type=style&index=0&id=b7a2ac5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports